"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const table_header_1 = require("./partials/table-header");
const table_rows_1 = require("./partials/table-rows");
const table_styles_1 = require("./table.styles");
const pagination_1 = require("../pagination");
const client_constants_1 = require("../../enrich-ai/client/client.constants");
const localization_1 = require("../../localization");
const Table = ({ data, isSelectable = true, columns, total, pageNumber, rowsPerPage, setPage, setPerPage, selected = [], selectedCount, onSelect = () => null, isLoading, error, onRowClick, onWholePageSelect = () => null, isWholePageSelected = false, className, children, noDataMessage, bulkActions, filter, updateFilter, sort, updateSort, rowSize, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const tableRef = (0, react_1.useRef)(null);
    return (react_1.default.createElement(table_styles_1.StyledTable, { className: className, "data-grid-viewport": true }, react_1.default.createElement(material_1.TableContainer, { ref: tableRef }, react_1.default.createElement(material_1.Table, null, react_1.default.createElement(table_header_1.TableHeader, { data: data, columns: columns, isMoreOption: !!onRowClick, isIndeterminate: selected.length > 0, isSelectedAll: isWholePageSelected, isSelectable: isSelectable, selectedCount: selectedCount, bulkActions: bulkActions, onSelectCurrentPage: onWholePageSelect, filter: filter, updateFilter: updateFilter, sort: sort, updateSort: updateSort, applyText: t({ key: 'APPLY' }), searchLabel: t({ key: 'SEARCH' }), numberFilterErrorText: "", itemsSelectedText: t({ key: 'ITEMS_SELECTED', values: { count: selectedCount, item: t({ key: 'PRODUCT' }) } }), okText: t({ key: 'OK' }), cancelText: t({ key: 'CANCEL' }), searchPlaceholderText: t({ key: 'SEARCH' }), selectAllText: t({ key: 'SELECT_ALL' }), clearText: t({ key: 'CLEAR' }) }), react_1.default.createElement(table_rows_1.TableRows, { isSelectable: isSelectable, data: data, onSelect: onSelect, columns: columns, isLoading: isLoading, error: error, onRowClick: onRowClick, noResultsText: noDataMessage, selectedItems: selected.map((row) => row.id), isMoreOption: false, reorderDisabledText: "", rowsPerPage: rowsPerPage > total ? total : rowsPerPage, rowSize: rowSize }), children), data.length > 0 && (react_1.default.createElement(table_styles_1.StyledTablePaginationContainer, null, react_1.default.createElement(pagination_1.TablePagination, { itemsCount: total, pageNumber: pageNumber, rowsPerPage: rowsPerPage, rowsPerPageOptions: client_constants_1.PAGE_SIZES, onPageChange: setPage, onRowsPerPageChange: setPerPage }))))));
};
exports.Table = Table;
